import "//shopakaso.com/cdn/shop/t/25/assets/swiper@11.min.js?v=104684603862494721831780911930"
import "//shopakaso.com/cdn/shop/t/25/assets/jquery.js?v=147293088974801289311780911872"

// 入口函数，在页面加载完成后执行
function main() {
    Alpine.data('storeInspiringmb', function () {
        const el = $(this);
        return {
            swiperOptionNine: {
                freeMode: {
                  enabled: true,
                  momentum: true,
                  momentumRatio: 0.5,
                  momentumVelocityRatio: 0.5,
                  momentumBounce: true,
                  momentumBounceRatio: 1,
                  minimumVelocity: 0.02,
                },
                initialSlide: 0,
                direction: 'horizontal',
                loop: true,
                autoplay: false,
                slidesPerView: 'auto',
                spaceBetween: 8,
                slidesOffsetBefore: 0,
                on: {
                  slideChangeTransitionEnd() {},
                },
            },
            localName: window.Shopify.locale,
            init() {
                $(function () {
                    /* 视频点击事件 */
                    $('.store-inspiring-video-player-mb').click(function () {
                        const video = $(this).siblings('.store-inspiring-video-mb').get(0)
                        $('.store-inspiring-video-mb')
                          .not(video)
                          .each(function () {
                            this.pause()
                          })
                        if (video.paused) {
                          video.play()
                          $(this).hide()
                        } else {
                          video.pause()
                          $(this).show()
                        }
                        $('.store-inspiring-video-player-mb').not(this).show()
                    })
                    /* 视频点击事件 */
                })
                this.initMB()
            }, // end init
            initMB() {
                this.initMBSwiper()
            },
            initMBSwiper() {
                new Swiper('.swiper-container-inspiring-mb', this.swiperOptionNine)
            },
        }
    })
}
document.addEventListener('alpine:init', main)